import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';
import swal from 'sweetalert';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { apiUrl } from '../../services/HttpInterceptorUtil';

interface ViewPaymentProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer
export default class ViewPayment extends React.Component<ViewPaymentProps> {
  @observable private payment: any;
  @observable private cfdis: any;
  @observable private id: any = "";
  @observable private isLoaded: boolean = false;
  @observable private redirect: boolean = false;
  @observable private web_name: string = (() => {
    if (process.env.NODE_ENV === "development") {
      return "develop";
    }

    const url = process.env.REACT_APP_URL;

    switch (url) {
      case "https://sur.serviciosinalambricos.com.mx":
      case "https://sur-2.serviciosinalambricos.com.mx":
      case "https://servicios-sur.web.app":
        return "sur";
      case "https://norte.serviciosinalambricos.com.mx":
      case "https://norte-2.serviciosinalambricos.com.mx":
        return "norte";
      case "https://wirserv.serviciosinalambricos.com.mx":
      case "https://wirserv-2.serviciosinalambricos.com.mx":
        return "wirserv";
      case "https://develop.serviciosinalambricos.com.mx":
        return "develop";
      default:
        console.warn(`Unexpected REACT_APP_URL in production: ${url}`);
        return "";
    }
  })();

  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }

  init = () => {
    const match = this.props.match;
    const id = (match as any).params.id;
    this.id = id;
    http
      .get(`/api/payment/read/${id}`)
      .then((response) => {
        this.payment = response.data;
      })
      .then(() => {
        this.getCfdiStatus();
      })
      .catch(() => {
        toast.error("Error cargando Recibo");
      });
  };

  private getCfdiStatus = (): void => {
    http.get(`/api/payment/cfdi_status/${this.payment.id}`).then((response) => {
          this.cfdis = response.data.response;
          this.isLoaded = true;
        });
  }

  private downLoadInvoice = (cfdi: any): void => {
    window.open(
      `${apiUrl().url.API_URL}/api/payment/factura_download/${this.id}/${cfdi}`,
      "_blank"
    );
  };

  private generateInvoice = (id: any): void => {
    http
      .get(`/api/payment/factura/${id}`)
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          toast.success("Factura generada correctamente");
          this.payment.cfdi = response.data.data.uuid;
          this.getCfdiStatus();
        } else {
          toast.error("Error generando factura");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Error generando factura: " + error);
      });
  };

  private cancelInvoice = (id: any): void => {
    swal({
      title: "Confirmar acción",
      text: "¿Estás seguro que quieres cancelar esta factura?",
      icon: "warning",
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        http
          .get(`/api/payment/factura_cancelacion/${id}`)
          .then((response) => {
            if (response.data.success === true) {
              toast.success("Factura cancelada correctamente");
              this.payment.cfdi =
                null;
                this.getCfdiStatus();
            } else {
              toast.error("Error cancelando factura");
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error("Error cancelando factura");
          });
      }
    });
  };

  render() {
    if (!this.isLoaded) {
      return null;
    }
    if (this.redirect) {
      return <Redirect to="/pagos" />;
    }
    return (
      <Fragment>
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">Pago: #{this.payment.id}</h4>
                </div>
              </div>
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-10"></div>
                  <div className="col-sm-2">
                    <Link to={`../../pagos`}>
                      <button className="btn btn-danger btn-sm  pull-right">
                        <i className="material-icons">highlight_off</i>
                        <div className="ripple-container"></div>
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8"></div>
                  <div className="col-sm-4" style={{ textAlign: "right" }}>
                    {sessionService.canViewSection("Pagos.delete") && (
                      <button
                        onClick={() => this.deletePayment(this.payment.id)}
                        style={{ margin: 5 }}
                        type="button"
                        className="btn btn-danger"
                      >
                        <i className="material-icons">close</i> Borrar
                      </button>
                    )}
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Cantidad</label>
                  <div className="col-sm-8">
                    <strong>${this.payment.amount}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Registrado por</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.created_by_name}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Registrado el</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.created_date}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Recibo #</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.invoice_id}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Recibo Adicional #</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.additional_id}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Tipo de Pago</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.type}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Metodo de Pago</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.method}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Pago en oficina</label>
                  <div className="col-sm-8">
                    <strong>
                      {Number(this.payment.paid_at_office) === 1 ? "Sí" : "No"}
                    </strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Direccion</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.address}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Folio</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.folio}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Tarjeta</label>
                  <div className="col-sm-8">
                    <strong>
                      {this.payment.card
                        ? this.payment.card
                        : this.payment.newcard}
                    </strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Fecha de deposito</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.date}</strong>
                  </div>
                </div>
                {this.payment.type === "Tecnico" && (
                  <div className="row">
                    <label className="col-sm-4">Pagado por</label>
                    <div className="col-sm-8">
                      <strong>{this.payment.paid_by}</strong>
                    </div>
                  </div>
                )}
                <div className="row">
                  <label className="col-sm-4">Notas:</label>
                  <div className="col-sm-8">
                    <strong>{this.payment.notes}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">Facturas</h4>
                </div>
              </div>
              <div className="card-body">
                {sessionService.canViewSection("Facturas.add") &&
                  this.payment.cfdi == null && (
                    <div className="row">
                      <div className="col-sm-12">
                        <div style={{ textAlign: "right" }}>
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() =>
                              this.generateInvoice(this.payment.id)
                            }
                          >
                            <i className="material-icons">add</i> Generar
                            Factura
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                {sessionService.canViewSection("Facturas.delete") &&
                  this.payment.cfdi != null && (
                    <div className="row">
                      <div className="col-sm-12">
                        <div style={{ textAlign: "right" }}>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => 
                              this.cancelInvoice(this.payment.id)
                            }
                          >
                            <i className="material-icons">close</i> Cancelar
                            Factura
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                <div className="row">
                  <div className="col-sm-12">
                    <table className="table table-hover">
                      <thead className="text-primary">
                        <tr>
                          <th>UUID</th>
                          <th>Estatus</th>
                          <th>Descargar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.cfdis.map((cfdi: any) => (
                          <tr key={cfdi.id}>
                            <td>{cfdi.cfdi}</td>
                            <td>{cfdi.status}</td>
                            <td>
                              <button
                                onClick={() => this.downLoadInvoice(cfdi.cfdi)}
                                className="btn btn-primary btn-sm"
                              >
                                <i className="material-icons">file_download</i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.payment.picture_id && (
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header card-header-rose card-header-text">
                  <div className="card-text">
                    <h4 className="card-title">Imágenes</h4>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div style={{ textAlign: "right", marginBottom: "10px" }}>
                        <Link to={`/pagos/editar/${this.payment.id}`}>
                          <button className="btn btn-primary btn-sm">
                            <i className="material-icons">edit</i> Editar imágenes
                          </button>
                        </Link>
                      </div>
                      <PhotoProvider>
                        {this.payment.picture_id.split(',').filter((id: string) => id && id.trim() !== '').map((pictureId: string, index: number) => {
                          const cleanId = pictureId.trim();
                          return (
                            <div key={cleanId} style={{ display: 'inline-block', margin: '5px' }}>
                              <PhotoView
                                src={`https://storage.googleapis.com/${this.web_name === "norte" ? "servicios-norte" : this.web_name === "wirserv" ? "servicios-wirserv" : this.web_name === "sur" ? "servicios-sur" : "servicios-develop"}/${this.web_name}/payments/${cleanId}.jpg`}
                              >
                                <img
                                  src={`https://storage.googleapis.com/${this.web_name === "norte" ? "servicios-norte" : this.web_name === "wirserv" ? "servicios-wirserv" : this.web_name === "sur" ? "servicios-sur" : "servicios-develop"}/${this.web_name}/payments/${cleanId}.jpg`}
                                  alt={`Imagen de recibo ${index + 1}`}
                                  style={{ width: '150px', height: '150px', objectFit: 'cover', cursor: 'pointer' }}
                                  onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                  }}
                                />
                              </PhotoView>
                            </div>
                          );
                        })}
                      </PhotoProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }

  private deletePayment = (id: any): void => {
    swal({
      title: "Confirmar acción",
      text: "¿Estas seguro que quieres borrar este pago?",
      icon: "warning",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const deleteObject = JSON.stringify({
          id,
        });
        http
          .post(`/api/payment/delete`, deleteObject)
          .then((response) => {
            toast.success("Pago borrado correctamente");
            this.redirect = true;
          })
          .catch((error) => {
            if (error.includes("foreign")) {
              toast.error("Error al borrar: Registros ligados a este pago");
            } else {
              toast.error("Error borrando pago");
            }
          });
      }
    });
  };
}